import { cn } from '@/lib/utils'

/** The one place plum is allowed to sit on a filled surface. */
export function Logo({
  className,
  showWordmark = true,
}: {
  className?: string
  showWordmark?: boolean
}) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <span className="flex size-5 items-center justify-center rounded-[4px] bg-plum">
        <span className="font-mono text-[10px] leading-none font-medium text-white">sp</span>
      </span>
      {showWordmark && <span className="text-[15px] font-medium tracking-[-0.02em]">seoplum</span>}
    </span>
  )
}
